// Servizio dominio EVENTI: vetrina pubblica + gestione CRM (admin/stakeholder).
import { api, unwrap } from './client';

const g = (path, params, config) => unwrap(api.get(path, { params, ...(config || {}) }));
const p = (path, body, config) => unwrap(api.post(path, body, config));
const u = (path, body, config) => unwrap(api.put(path, body, config));
const d = (path, config) => unwrap(api.delete(path, config));

export const eventsService = {
  // ---- Vetrina pubblica ----
  publicList: (category) => g('/events/public', category && category !== 'tutte' ? { category } : {}),
  publicCategories: () => g('/events/public/categories'),
  publicByOwner: (ownerId) => g(`/events/public/by-owner/${ownerId}`),
  publicGet: (idOrSlug) => g(`/events/public/${idOrSlug}`),
  checkout: (body) => p('/events/public/checkout', body),
  // Checkout Stripe reale (Payment Element, anche ospite senza login)
  checkoutIntent: (body) => p('/events/public/checkout/intent', body),
  checkoutConfirm: (orderId) => p('/events/public/checkout/confirm', { order_id: orderId }),

  // ---- Modulo (stakeholder) ----
  moduleStatus: () => g('/events/module'),
  activateModule: () => p('/events/module/activate'),

  // ---- Gestione eventi (stakeholder abilitato + admin) ----
  list: (params) => g('/events', params),
  get: (eid) => g(`/events/${eid}`),
  create: (body) => p('/events', body),
  update: (eid, body) => u(`/events/${eid}`, body),
  setStatus: (eid, status) => p(`/events/${eid}/status`, { status }),
  remove: (eid) => d(`/events/${eid}`),

  // ---- Categorie (admin) ----
  categories: () => g('/events/categories'),
  createCategory: (body) => p('/events/categories', body),
  updateCategory: (slug, body) => u(`/events/categories/${slug}`, body),
  deleteCategory: (slug) => d(`/events/categories/${slug}`),

  // ---- Approvazioni modulo (admin) ----
  moduleRequests: (status) => g('/events/admin/module-requests', status ? { status } : {}),
  decideModule: (ownerId, approve, note) => p(`/events/admin/module-requests/${ownerId}/decide`, { approve, note }),

  // ---- Check-in biglietti (owner/admin) ----
  checkin: (code) => p('/events/checkin', { code }),

  // ---- Biglietti venduti ----
  ordersOverview: () => g('/events/orders/overview'),
  eventOrders: (eid, sessionId) => g(`/events/${eid}/orders`, sessionId ? { session_id: sessionId } : {}),
  ordersCsvBlob: (eid, sessionId) =>
    g(`/events/${eid}/orders.csv`, sessionId ? { session_id: sessionId } : {}, { responseType: 'blob' }),
  ordersPdfBlob: (eid, sessionId) =>
    g(`/events/${eid}/orders.pdf`, sessionId ? { session_id: sessionId } : {}, { responseType: 'blob' }),
};

// URL assoluto del QR reale (riusa l'endpoint biglietteria: codifica /biglietto/{code}).
const BACKEND = process.env.REACT_APP_BACKEND_URL || '';
export const eventQrUrl = (code) => `${BACKEND}/api/experience/public/qr/${encodeURIComponent(code)}.png`;

// URL assoluto della locandina social (PNG) di un evento pubblicato.
export const eventPosterUrl = (idOrSlug) => `${BACKEND}/api/events/public/${encodeURIComponent(idOrSlug)}/poster.png`;

// URL assoluto della ricevuta PDF (non fiscale) di un ordine biglietti.
export const eventReceiptUrl = (code) => `${BACKEND}/api/events/public/orders/${encodeURIComponent(code)}/receipt.pdf`;
// URL pubblico condivisibile dell'evento.
export const eventPublicUrl = (slug) => `${window.location.origin}/eventi/${slug}`;
